import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import defaultThemes from './themes.js';
import themeConfig from '../../themes.conf.js';
import hcPackage from '../../package.json.js';
import { appendStyles, CLIENT_ID_NAMESPACE } from '../../packages/injecss/injecss.js';

var verSuffix = hcPackage.version.replace(/\./g, '-');
/**
 * Here we basically simulate the output of "sass-unique-classes loader" existing configuration.
 * The output is a CSS string with all the design tokens and theme default styles.
 * @param themes
 */
var generateStylesObject = function (themes) {
  var themeNames = Object.keys(themes);
  var cssString = themeNames.map(function (themeName) {
    var themeTokens = Object.keys(themes[themeName]);
    var themeTokenValues = Object.values(themes[themeName]);
    // @todo find a better way to reduce the style duplication
    return "\n.hcr-theme-".concat(themeName, "-").concat(verSuffix).concat(themeName === 'default' ? ', :root' : '', " {\n  ").concat(themeTokens.map(function (token, tokenIndex) {
      return "--hcr-".concat(token, ": ").concat(themeTokenValues[tokenIndex], ";");
    }).join(' '), "\n}\n.hcr-theme-").concat(themeName, "-").concat(verSuffix).concat(themeName === 'default' ? ', :root' : '', " {\n  color: var(--hcr-content-primary-color);\n  font-family: var(--hcr-font-family-primary);\n  font-size: var(--hcr-font-size-primary);\n  font-weight: var(--hcr-font-weight-normal);\n  line-height: var(--hcr-line-height-primary);\n}");
  });
  return {
    raw: cssString.join(' ')
  };
};
var ThemeWrapper = function (_a) {
  var children = _a.children,
    theme = _a.theme,
    _b = _a.themes,
    themes = _b === void 0 ? defaultThemes : _b,
    rest = __rest(_a, ["children", "theme", "themes"]);
  var themeClassName = "hcr-theme-".concat(theme, "-").concat(verSuffix);
  // merge default and custom theme object,
  // so the default theme is always there even when not provided
  var themeObject = __assign(__assign({}, defaultThemes), themes);
  var styles = generateStylesObject(themeObject);
  // adding themes to style element ID,
  // in order to allow for multiple theme wrapper usages on one page with different theme setups
  // so they want override each other
  appendStyles("ThemeWrapper__".concat(Object.keys(themeObject).join('-')).concat(CLIENT_ID_NAMESPACE).concat(verSuffix), styles.raw);
  return /*#__PURE__*/React__default__default.createElement("div", __assign({
    className: themeClassName
  }, rest), children);
};
ThemeWrapper.displayName = 'ThemeWrapper';
ThemeWrapper.defaultProps = {
  theme: 'default',
  themes: defaultThemes
};
ThemeWrapper.propTypes = {
  children: PropTypes__default.node.isRequired,
  theme: PropTypes__default.oneOf(themeConfig.honeycombThemes),
  themes: PropTypes__default.object
};

export { ThemeWrapper, ThemeWrapper as default, generateStylesObject };
